//
//
//
//
//
//
//

import { faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons'
import { faHeart as solidHeart } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'TaskLikes',
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      liking: false,
      liked: false
    }
  },
  computed: {
    heartIcon () {
      return this.liked ? solidHeart : regularHeart
    },
    disabled () {
      return !this.$auth.loggedIn ||
        !this.$store.getters['user/isFreelancer'] ||
        this.loading ||
        this.liking ||
        !this.$store.getters['user/getFreelancer']?.published ||
        !this.$store.getters['user/getFreelancer']?.confirmed
    }
  },
  async mounted () {
    if (this.$store.getters['user/isFreelancer']) {
      try {
        this.loading = true
        const { data } = await this.$axios.get(`/tasks/${this.task.id}/liked`)
        this.liked = data.data.liked
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    }
  },
  methods: {
    async toggle () {
      try {
        this.liking = true
        await this.$store.dispatch('tasks/toggleTaskLikes', this.task.id)
        this.liked = !this.liked
        this.liking = false
      } catch (err) {
        this.liking = false
      }
    }
  }
}
